import React from 'react'
import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import HelpPane from 'components/Common/HelpPane'

const ModalContent = styled.div`
  padding-top: ${rem(16)};
`

interface Props {
  title: string
  hideExcludesFlights: boolean
  cancellationPolicyType?: App.CancellationPolicyType
  cancellationPolicyLines?: Array<string>
}

function ConnectionCancellationPolicyModal(props: Props) {
  const {
    title,
    hideExcludesFlights,
    cancellationPolicyType,
    cancellationPolicyLines,
  } = props
  const intl = useIntl()

  const accommodationOnlyNote = intl.formatMessage({
    id: '2kV68ssh46VgLN3VIR3R',
    defaultMessage: 'Please note: cancellation policies apply to accommodation bookings only.',
    description: 'Disclaimer that cancellation policies apply to accommodation only, when flights exclusion note is not shown',
  })
  const accommodationOnlyExcludesFlightsNote = intl.formatMessage({
    id: 'Az081934_hcx0G1KV9mk',
    defaultMessage: 'Please note: cancellation policies apply to accommodation bookings only, excludes flights.',
    description: 'Disclaimer that cancellation policies apply to accommodation only and excludes flights',
  })

  return <Modal
    title={title}
  >
    <ModalContent>
      {cancellationPolicyLines?.map(line => <BodyText variant="large" as="p" key={line}>{ line }</BodyText>)}
      {cancellationPolicyType == 'dynamic' &&
        <BodyText variant="large" as="p">{hideExcludesFlights ? accommodationOnlyNote : accommodationOnlyExcludesFlightsNote}</BodyText>}
      <HelpPane />
    </ModalContent>
  </Modal>
}

export default ConnectionCancellationPolicyModal
